// JUEGO 5: EL IMPOSTOR
// ==========================================
export const PALABRAS_IMPOSTOR = [
    { word: "Manzana", hint: "Comida" },
    { word: "Médico", hint: "Profesión" },
    { word: "Biblioteca", hint: "Lugar" },
    { word: "Reloj", hint: "Objeto" },
    { word: "León", hint: "Animal" },
    { word: "Astronauta", hint: "Profesión" },
    { word: "Playa", hint: "Lugar" },
    { word: "Paraguas", hint: "Objeto" },
    { word: "Pingüino", hint: "Animal" },
    { word: "Bombero", hint: "Profesión" },
    { word: "Cine", hint: "Lugar" },
    { word: "Guitarra", hint: "Instrumento" },
    { word: "Elefante", hint: "Animal" },
    { word: "Chef", hint: "Profesión" },
    { word: "Montaña", hint: "Lugar" },
    { word: "Gafas", hint: "Objeto" },
    { word: "Delfín", hint: "Animal" },
    { word: "Piloto", hint: "Profesión" },
    { word: "Hospital", hint: "Lugar" },
    { word: "Libro", hint: "Objeto" },
    { word: "Tigre", hint: "Animal" },
    { word: "Arquitecto", hint: "Profesión" },
    { word: "Parque", hint: "Lugar" },
    { word: "Mochila", hint: "Objeto" },
    { word: "Águila", hint: "Animal" },
    { word: "Carpintero", hint: "Profesión" },
    { word: "Museo", hint: "Lugar" },
    { word: "Llave", hint: "Objeto" },
    { word: "Canguro", hint: "Animal" },
    { word: "Abogado", hint: "Profesión" },
    { word: "Restaurante", hint: "Lugar" },
    { word: "Teléfono", hint: "Objeto" },
    { word: "Jirafa", hint: "Animal" },
    { word: "Dentista", hint: "Profesión" },
    { word: "Escuela", hint: "Lugar" },
    { word: "Cuchara", hint: "Objeto" },
    { word: "Oso", hint: "Animal" },
    { word: "Policía", hint: "Profesión" },
    { word: "Estación", hint: "Lugar" },
    { word: "Cámara", hint: "Objeto" },
    { word: "Serpiente", hint: "Animal" },
    { word: "Ingeniero", hint: "Profesión" },
    { word: "Gimnasio", hint: "Lugar" },
    { word: "Zapatos", hint: "Objeto" },
    { word: "Lobo", hint: "Animal" },
    { word: "Profesor", hint: "Profesión" },
    { word: "Supermercado", hint: "Lugar" },
    { word: "Escalera", hint: "Objeto" },
    { word: "Mono", hint: "Animal" },
    { word: "Enfermera", hint: "Profesión" },
    { word: "Aeropuerto", hint: "Lugar" },
    { word: "Espejo", hint: "Objeto" },
    { word: "Ballena", hint: "Animal" },
    { word: "Pintor", hint: "Profesión" },
    { word: "Banco", hint: "Lugar" },
    { word: "Cuaderno", hint: "Objeto" },
    { word: "Tiburón", hint: "Animal" },
    { word: "Mecánico", hint: "Profesión" },
    { word: "Teatro", hint: "Lugar" },
    { word: "Lámpara", hint: "Objeto" },
    { word: "Zorro", hint: "Animal" },
    { word: "Periodista", hint: "Profesión" },
    { word: "Desierto", hint: "Lugar" },
    { word: "Almohada", hint: "Objeto" },
    { word: "Conejo", hint: "Animal" },
    { word: "Veterinario", hint: "Profesión" },
    { word: "Selva", hint: "Lugar" },
    { word: "Televisión", hint: "Objeto" },
    { word: "Búho", hint: "Animal" },
    { word: "Panadero", hint: "Profesión" },
    { word: "Jardín", hint: "Lugar" },
    { word: "Bolígrafo", hint: "Objeto" },
    { word: "Caballo", hint: "Animal" },
    { word: "Electricista", hint: "Profesión" },
    { word: "Iglesia", hint: "Lugar" },
    { word: "Cinturón", hint: "Objeto" },
    { word: "Tortuga", hint: "Animal" },
    { word: "Programador", hint: "Profesión" },
    { word: "Oficina", hint: "Lugar" },
    { word: "Computadora", hint: "Objeto" },
    { word: "Mariposa", hint: "Animal" },
    { word: "Soldado", hint: "Profesión" },
    { word: "Castillo", hint: "Lugar" },
    { word: "Sombrero", hint: "Objeto" },
    { word: "Rana", hint: "Animal" },
    { word: "Psicólogo", hint: "Profesión" },
    { word: "Farmacia", hint: "Lugar" },
    { word: "Maleta", hint: "Objeto" },
    { word: "Ardilla", hint: "Animal" },
    { word: "Agricultor", hint: "Profesión" },
    { word: "Circo", hint: "Lugar" },
    { word: "Botella", hint: "Objeto" },
    { word: "Cabra", hint: "Animal" },
    { word: "Taxista", hint: "Profesión" },
    { word: "Zapatería", hint: "Lugar" },
    { word: "Silla", hint: "Objeto" },
    { word: "Araña", hint: "Animal" },
    { word: "Cantante", hint: "Profesión" },
    { word: "Panadería", hint: "Lugar" },
    { word: "Cuchillo", hint: "Objeto" },
    { word: "Piano", hint: "Instrumento" },
    { word: "Avión", hint: "Transporte" },
    { word: "Cangrejo", hint: "Animal" },
    { word: "Sartén", hint: "Objeto" },
    { word: "Volcán", hint: "Lugar" },
    { word: "Camarero", hint: "Profesión" },
    { word: "Cueva", hint: "Lugar" },
    { word: "Brújula", hint: "Objeto" },
    { word: "Bailarín", hint: "Profesión" },
    { word: "Halcón", hint: "Animal" },
    { word: "Fresa", hint: "Fruta" },
    { word: "Destornillador", hint: "Herramienta" },
    { word: "Glaciar", hint: "Geografía" },
    { word: "Bufanda", hint: "Ropa" },
    { word: "Telescopio", hint: "Instrumento" },
    { word: "Tenis", hint: "Deporte" },
    { word: "Serrucho", hint: "Herramienta" },
    { word: "Cráter", hint: "Geografía" },
    { word: "Camiseta", hint: "Ropa" },
    { word: "Violín", hint: "Instrumento" },
    { word: "Pera", hint: "Fruta" },
    { word: "Alicates", hint: "Herramienta" },
    { word: "Cascada", hint: "Geografía" },
    { word: "Pantalones", hint: "Ropa" },
    { word: "Termómetro", hint: "Objeto" },
    { word: "Fútbol", hint: "Deporte" },
    { word: "Taladro", hint: "Herramienta" },
    { word: "Valle", hint: "Geografía" },
    { word: "Falda", hint: "Ropa" },
    { word: "Flauta", hint: "Instrumento" },
    { word: "Ciruela", hint: "Fruta" },
    { word: "Llave inglesa", hint: "Herramienta" },
    { word: "Oasis", hint: "Geografía" },
    { word: "Gorro", hint: "Ropa" },
    { word: "Microscopio", hint: "Objeto" },
    { word: "Baloncesto", hint: "Deporte" },
    { word: "Sierra", hint: "Herramienta" },
    { word: "Cañón", hint: "Geografía" },
    { word: "Vestido", hint: "Ropa" },
    { word: "Tambor", hint: "Instrumento" },
    { word: "Uva", hint: "Fruta" },
    { word: "Martillo", hint: "Herramienta" },
    { word: "Isla", hint: "Geografía" },
    { word: "Guantes", hint: "Ropa" },
    { word: "Prismáticos", hint: "Objeto" },
    { word: "Natación", hint: "Deporte" },
    { word: "Clavo", hint: "Objeto" },
    { word: "Acantilado", hint: "Geografía" },
    { word: "Calcetines", hint: "Ropa" },
    { word: "Trompeta", hint: "Instrumento" },
    { word: "Melocotón", hint: "Fruta" },
    { word: "Llana", hint: "Herramienta" },
    { word: "Bahía", hint: "Geografía" },
    { word: "Corbata", hint: "Ropa" },
    { word: "Sextante", hint: "Objeto" },
    { word: "Voleibol", hint: "Deporte" },
    { word: "Regla", hint: "Herramienta" },
    { word: "Pantano", hint: "Geografía" },
    { word: "Chaqueta", hint: "Ropa" },
    { word: "Saxofón", hint: "Instrumento" },
    { word: "Naranja", hint: "Fruta" },
    { word: "Metro", hint: "Herramienta" },
    { word: "Puerto", hint: "Geografía" },
    { word: "Camisa", hint: "Ropa" },
    { word: "Lupa", hint: "Objeto" },
    { word: "Boxeo", hint: "Deporte" },
    { word: "Tornillo", hint: "Objeto" },
    { word: "Estrecho", hint: "Geografía" },
    { word: "Abrigo", hint: "Ropa" },
    { word: "Clarinete", hint: "Instrumento" },
    { word: "Sandía", hint: "Fruta" },
    { word: "Pinzas", hint: "Herramienta" },
    { word: "Península", hint: "Geografía" },
    { word: "Jersey", hint: "Ropa" },
    { word: "Báscula", hint: "Objeto" },
    { word: "Ciclismo", hint: "Deporte" },
    { word: "Tuerca", hint: "Objeto" },
    { word: "Cabo", hint: "Geografía" },
    { word: "Chaleco", hint: "Ropa" },
    { word: "Arpa", hint: "Instrumento" },
    { word: "Piña", hint: "Fruta" },
    { word: "Nivel", hint: "Herramienta" },
    { word: "Golfo", hint: "Geografía" },
    { word: "Blusa", hint: "Ropa" },
    { word: "Cronómetro", hint: "Objeto" },
    { word: "Atletismo", hint: "Deporte" },
    { word: "Escuadra", hint: "Herramienta" },
    { word: "Archipiélago", hint: "Geografía" },
    { word: "Tuba", hint: "Instrumento" },
    { word: "Plátano", hint: "Fruta" },
    { word: "Compás", hint: "Herramienta" },
    { word: "Albufera", hint: "Geografía" },
    { word: "Pijama", hint: "Ropa" },
    { word: "Calculadora", hint: "Objeto" },
    { word: "Judo", hint: "Deporte" },
    { word: "Pincel", hint: "Objeto" },
    { word: "Ría", hint: "Geografía" },
    { word: "Medias", hint: "Ropa" },
    { word: "Triángulo", hint: "Instrumento" },
    { word: "Kiwi", hint: "Fruta" },
    { word: "Lima", hint: "Herramienta" },
    { word: "Montículo", hint: "Geografía" },
    { word: "Calzoncillos", hint: "Ropa" },
    { word: "Batuta", hint: "Objeto" },
    { word: "Kárate", hint: "Deporte" },
    { word: "Frambuesa", hint: "Fruta" },
    { word: "Cincel", hint: "Herramienta" },
    { word: "Pradera", hint: "Geografía" },
    { word: "Bañador", hint: "Ropa" },
    { word: "Xilófono", hint: "Instrumento" }
  ];
  
  
  // ==========================================
  // JUEGO 8: RULETA RUSA (PREGUNTAS)
  // ==========================================
  export const PREGUNTAS_RULETA = [
      "¿Crees en Dios? Justifica tu respuesta",
      "¿Cuál ha sido la lección más grande que has aprendido hasta ahora?",
      "¿Cuál es el mayor reto que has superado y cómo te cambió?",
      "¿De qué te arrepientes más?",
      "¿Qué es lo mejor que te ha pasado en la vida?",
      "¿Qué es lo que más admiras en los demás?",
      "¿Qué experiencia ha definido más quién eres hoy?",
      "¿Cuál es tu filosofía de vida o lema personal?",
      "¿Qué valoras más: la estabilidad o la aventura?",
      "Si pudieras cambiar algo sobre como funcionamos los humanos, ¿qué sería?",
      "¿Cuál es tu propósito principal en la vida?",
      "¿Cuándo fue la última vez que lloraste y por qué?",
      "¿Qué te hace sentir que tu vida tiene sentido?",
      "¿Cuál es tu mayor sueño por cumplir?",
      "Si el dinero no fuera un problema, ¿a qué dedicarías tu tiempo?",
      "¿Cómo te ves a ti mismo de aquí a 5 años?",
      "¿Qué habilidad te gustaría dominar?",
      "¿Qué es lo que más valoras en una amistad? ¿y en una pareja?",
      "¿Qué aprendiste de tu última relación?",
      "Si tuvieras que estar encerrado 30 dias en una habitación, ¿a qué persona conocida te llevarias como compañia?",
      "Si solo pudieras comer una cosa el resto de tu vida ¿que elegirías?",
      "Si te fueran a ejecutar, y te ofrecen una último plato de comida ¿que elegirías?",
      "Si te toca 1 Millón de $ en la lotería en qué lo gastarías / invertirías?",
      "Si pudieras conocer a una persona histórica ¿a quien eliges?",
      "Si pudieras volver al pasado para contemplar un suceso histórico ¿cual sería?",
      "Si solo pudieras realizar una actividad el resto de tu vida ¿cual seria? (aparte de tus necesidades básicas)",
      "¿Que canción elegirías para escuchar en bucle el resto de tu vida?",
      "¿A quién pondrías como presidente de tu país? (no vale elegirte a ti)",
      "¿A qué persona elegirías para confiarle toda tu vida? (Tu salud, relaciones y pertenencias estarían en sus manos)",
      "¿Qué ley pondrías primero en tu país si fueras elegido presidente?",
      "¿Qué cosa prohibirías mundialmente?",
      "¿Qué estadística o número querrías conocer de todas las personas que veas? (por ejemplo cuantas veces han mentido en su vida)",
      "¿Qué harías hoy si fuera tu último día de vida?",
      "Si pudieras borrar algo de tu pasado, ¿qué sería?",
      "¿Qué es lo que más miedo te da en la vida?",
      "Si te fueran a meter en la cárcel 10 años y solo pudieras llevarte 1 objeto, ¿cual sería? (No puede funcionar con electricidad)",
      "¿Qué animal salvaje elegirías para tener de mascota? (contigo será inofensivo)"
  ];

// ==========================================
  // JUEGO 9: JUICIO FINAL
  // ==========================================
  export const CUALIDADES_JUICIO = [
      "belleza facial", "belleza corporal", "sentido del humor", "inteligencia", 
      "lealtad", "higiene", "estilo al vestir", "capacidad de ligar",
      "soberbia", "envidia", "ira y mal genio", "pereza", "tacañería",
      "amabilidad", "astucia", "manipulación", "empatía", "educación",
      "limpieza de su casa", "disciplina", "valores morales", "elegancia",
      "humildad", "elocuencia", "cultura general", "impulsividad",
      "caballerosidad", "ambición", "generosidad", "agilidad", "fuerza",
      "presencia", "estilo", "humor", "carisma", "puntualidad",
      "compasión", "coherencia", "apego emocional", "valentía",
      "gula", "violencia", "avaricia", "vanidad", "orgullo",
      "terquedad", "desorden", "temeridad", "optimismo", "sinceridad",
      "prudencia", "responsabilidad", "paciencia", "gratitud",
      "creatividad", "perseverancia", "sociabilidad", "curiosidad",
      "entusiasmo", "fidelidad", "lealtad", "egocentrismo",
      "cinismo", "hipocresía", "ironía", "descaro", "austeridad",
      "pasividad", "tomar buenas decisiones", "iniciativa", "cercanía"
  ];